"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveFavOptions = exports.getFavOptios = exports.getShortcutNavigationOptions = exports.selectingPersonDetail = exports.getPersonPysicalSiteClaims = exports.getPersonasForUserApp = exports.getUserSessionService = exports.getJwtTokenSN = exports.isActionTrackingToBeAcknowledged = exports.findByUserAppAndFunctions = exports.findByUserApps = exports.performEsignAuth = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _apolloClient = _interopRequireDefault(require("cornerstone_ui_core/lib/apolloClient"));

var _createWorkflowAppolloClient = _interopRequireDefault(require("../../utils/createWorkflowAppolloClient"));

var _constants = require("../../constants");

var _utils = require("cornerstone_ui_core/lib/utils");

var _externalSupplierNetClient = _interopRequireDefault(require("../../externalSupplierNetClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        mutation($input: FavOptionsVO) {\n          saveFavOptions(input: $input) {\n            id\n            statusMessage\n            statusCode\n          }\n        }\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        {\n          favOptions: getFavOptios (pageKey:\"", "\") {\n            menuOption\n            menuCategory\n            subCategory\n            functionKey\n            catOrder\n          }\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        {\n          menusFromDB: getShortcutNavigationOptions {\n            option\n            categoryVOList {\n              menuCategory\n              functionKey\n              pathUrl\n              subCategoryVOList {\n                subCategory\n                functionKey\n                pathUrl\n              }\n            }\n          }\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      mutation{\n        locationDetail: selectingPersonDetail(userNumId:", ", primary:", "){\n          statusMessage \n          id\n          statusCode\n        }}\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        {\n          physicalSiteClaims: getPersonPysicalSiteClaims {\n            userNumId\n            perId\n            phsId\n            prlId\n            active\n            primary\n            userId\n            location\n            siteDescription\n            siteAddress\n          }\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        query getAllActionTrackingMyselfPaged(\n          $input: ActionTrackingPagedRequestVO\n        ) {\n          getAllActionTrackingMyselfPaged(input: $input) {\n            pageCount\n          }\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        query($input: EsignAuthorisation) {\n          performEsignAuth(input: $input)\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GRAPHQL_RDS_GATEWAY_BASE_URL = process.env.NODE_ENV === "production" ? "/gateway_rds" + _constants.servicegraphql : _constants.servicebasepath + "/gateway_rds" + _constants.servicegraphql;
var gatewayclientRDS = (0, _createWorkflowAppolloClient.default)(GRAPHQL_RDS_GATEWAY_BASE_URL, {
  appName: "RDS"
});
var GRAPHQL_SCS_GATEWAY_BASE_URL = process.env.NODE_ENV === "production" ? "/gateway_scs" + _constants.servicegraphql : _constants.servicebasepath + "/gateway_scs" + _constants.servicegraphql;
var gatewayclientSCS = (0, _createWorkflowAppolloClient.default)(GRAPHQL_SCS_GATEWAY_BASE_URL, {
  appName: "SCS"
}); // export const performEsignAuth = input => {
//   return client
//     .query({
//       query: gql`
//         query($input: EsignAuthorisation) {
//           performEsignAuth(input: $input)
//         }
//       `,
//       variables: {
//         input
//       }
//     })
//     .then(({ data, errors }) => {
//       if (!errors) {
//         return data;
//       }
//     })
//     .catch(errorHandler);
// };

var performEsignAuth = function performEsignAuth(input) {
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)(_templateObject()),
    variables: {
      input: input
    }
  }).then(function (_ref) {
    var data = _ref.data,
        errors = _ref.errors;

    if (!errors) {
      return data;
    }
  }).catch(_utils.errorHandler);
};

exports.performEsignAuth = performEsignAuth;

var findByUserApps = function findByUserApps(userId) {
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)("\n        {\n          findByUserApps(userId: \"".concat(userId, "\") {\n            userId\n            appNames\n            brands\n            roles {\n              appName\n              appRoles\n              appFns\n              jwtToken\n             jwtCacheKey\n            }\n          }\n        }\n    ")),
    fetchPolicy: "network-only"
  }).then(function (_ref2) {
    var data = _ref2.data;
    return data.findByUserApps;
  });
};

exports.findByUserApps = findByUserApps;

var findByUserAppAndFunctions = function findByUserAppAndFunctions(_ref3) {
  var _ref3$appName = _ref3.appName,
      appName = _ref3$appName === void 0 ? "" : _ref3$appName,
      userId = _ref3.userId;
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)("\n      {\n        brands: findByUserApps(userId: \"".concat(userId, "\") {\n          brands\n        }\n        userAppFunctions : findByUserAppAndFunctions(appName: \"").concat(appName, "\", userId :\"").concat(userId, "\"){\n          userId\n          jwtToken\n          appName\n          appRoles\n          appFns\n          rdsPerId\n          userNumber\n          cc{\n            v\n            k\n          }\n        }\n        userinfo : getUser(userId: \"").concat(userId, "\") {\n          userId\n          firstName\n          lastName\n          Dept\n\t\t      emailId\t\n        }\n        profileImage : getProfileImage(userId: \"").concat(userId, "\") {\n          userId\n          firstName\n          lastName\n          profileImage\n        }\n      }\n    ")),
    fetchPolicy: "network-only"
  }).then(function (_ref4) {
    var data = _ref4.data;
    return data;
  }).then(function (_ref5) {
    var brands = _ref5.brands,
        userinfo = _ref5.userinfo,
        userAppFunctions = _ref5.userAppFunctions,
        profileImage = _ref5.profileImage;
    var userInfoTemp = [];
    if (userinfo && userinfo.length > 0) userInfoTemp = _objectSpread(_objectSpread({}, userinfo[0]), {}, {
      email: userinfo[0].emailId,
      name: "".concat(userinfo[0].firstName, " ").concat(userinfo[0].lastName),
      department: userinfo[0]
    });

    var newUserAppFunctions = _objectSpread({}, userAppFunctions);

    var personId = userAppFunctions.rdsPerId;
    newUserAppFunctions.personId = personId;
    return {
      brands: brands,
      userinfo: userInfoTemp,
      userAppFunctions: newUserAppFunctions,
      profileImage: profileImage
    };
  });
};

exports.findByUserAppAndFunctions = findByUserAppAndFunctions;

var isActionTrackingToBeAcknowledged = function isActionTrackingToBeAcknowledged(input) {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject2()),
    variables: {
      input: input,
      shouldSuppressTimeoutError: true,
      isToDo: true
    }
  }).then(function (_ref6) {
    var data = _ref6.data;
    return data.getAllActionTrackingMyselfPaged;
  });
};

exports.isActionTrackingToBeAcknowledged = isActionTrackingToBeAcknowledged;

var getJwtTokenSN = function getJwtTokenSN(userId, appName) {
  return _externalSupplierNetClient.default.query({
    query: (0, _graphqlTag.default)("\n    {\n      getJWTTokenSNWithoutCong(userId: \"".concat(userId, "\", appName: \"").concat(appName, "\") {\n        jwtToken\n        jwtCacheKey\n      }\n    }\n")),
    fetchPolicy: "network-only"
  }).then(function (_ref7) {
    var data = _ref7.data;
    return data.getJWTTokenSNWithoutCong;
  });
};

exports.getJwtTokenSN = getJwtTokenSN;

var getUserSessionService = function getUserSessionService(cacheKey) {
  return _externalSupplierNetClient.default.query({
    query: (0, _graphqlTag.default)("\n    {\n      getUserSession(identifierKey: \"".concat(cacheKey, "\") {\n        userId\n        cacheKey\n        jwtToken\n      }\n    }\n")),
    fetchPolicy: "network-only"
  }).then(function (_ref8) {
    var data = _ref8.data;
    return data.getUserSession;
  });
};

exports.getUserSessionService = getUserSessionService;

var getPersonasForUserApp = function getPersonasForUserApp(userId, appName) {
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)("\n     {\n      getPersonasForUserApp(userId: \"".concat(userId, "\", appName: \"").concat(appName, "\") {\n        personaName\n        personaDesc\n      }\n    }\n  ")),
    fetchPolicy: "network-only"
  }).then(function (_ref9) {
    var data = _ref9.data;
    return data.getPersonasForUserApp;
  });
};

exports.getPersonasForUserApp = getPersonasForUserApp;

var getPersonPysicalSiteClaims = function getPersonPysicalSiteClaims() {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject3()),
    fetchPolicy: "no-cache"
  }).then(function (_ref10) {
    var data = _ref10.data,
        errors = _ref10.errors;

    if (!errors) {
      data.physicalSiteClaims = data.physicalSiteClaims && data.physicalSiteClaims.length > 0 && data.physicalSiteClaims.sort(function (a, b) {
        return a.primary - b.primary;
      });
      return data;
    } else return errors;
  }).catch(function (err) {
    return console.log(err);
  });
};

exports.getPersonPysicalSiteClaims = getPersonPysicalSiteClaims;

var selectingPersonDetail = function selectingPersonDetail(_ref11) {
  var userNumId = _ref11.userNumId,
      primary = _ref11.primary;
  return gatewayclientRDS.mutate({
    mutation: (0, _graphqlTag.default)(_templateObject4(), userNumId, primary)
  }).then(function (_ref12) {
    var data = _ref12.data;
    return data;
  }).catch(_utils.errorHandler);
};

exports.selectingPersonDetail = selectingPersonDetail;

var getShortcutNavigationOptions = function getShortcutNavigationOptions() {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject5()),
    fetchPolicy: "network-only"
  }).then(function (_ref13) {
    var data = _ref13.data,
        errors = _ref13.errors;
    return data;
  }).catch(function (err) {
    return console.log(err);
  });
};

exports.getShortcutNavigationOptions = getShortcutNavigationOptions;

var getFavOptios = function getFavOptios(pageKey) {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject6(), pageKey),
    fetchPolicy: "network-only"
  }).then(function (_ref14) {
    var data = _ref14.data,
        errors = _ref14.errors;
    return data;
  }).catch(_utils.errorHandler);
};

exports.getFavOptios = getFavOptios;

var saveFavOptions = function saveFavOptions(input) {
  return gatewayclientRDS.mutate({
    mutation: (0, _graphqlTag.default)(_templateObject7()),
    variables: {
      input: input
    }
  }).then(function (_ref15) {
    var data = _ref15.data;
    return data;
  }).catch(_utils.errorHandler);
};

exports.saveFavOptions = saveFavOptions;